import React from 'react';
import { render } from "react-dom";
import CMS from './utils/cms';
import registerServiceWorker from './utils/modules/registerServiceWorker';

render(<CMS />, document.getElementById('layout'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js